export function parseMailboxAddresses(text: string, domain: string, required: boolean): string[] {
  const addresses = text.split('\n').map((line) => line.trim().toLowerCase()).filter(Boolean);
  if (required && addresses.length === 0) throw new Error('Keep at least one exact email address for this mailbox.');
  if (new Set(addresses).size !== addresses.length) throw new Error('Remove duplicate addresses.');
  for (const address of addresses) {
    if (!/^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-z0-9.-]+$/.test(address) || address.split('@')[1] !== domain) {
      throw new Error(`Enter one email address per line, all in ${domain}.`);
    }
  }
  return addresses;
}
export function retainNewestDraft<T extends { revision: number }>(current: T | null, incoming: T): T {
  return current && current.revision > incoming.revision ? current : incoming;
}

export function primaryMailboxAddress(primaryEmail: string | null | undefined): string | null {
  const explicit = primaryEmail?.trim().toLowerCase();
  return explicit || null;
}

export function additionalMailboxAddresses(addresses: string[], primaryEmail: string | null): string[] {
  if (!primaryEmail) return addresses;
  const normalizedPrimary = primaryEmail.trim().toLowerCase();
  return addresses.filter((address) => address.trim().toLowerCase() !== normalizedPrimary);
}

export function uniqueMailboxIds(values: Array<string | null | undefined>): string[] {
  return Array.from(new Set(values.map((value) => value?.trim()).filter((value): value is string => Boolean(value))));
}

export function catchAllMailboxIds(value: {
  catchAllMailboxes?: string[] | null;
  catchAllMailbox?: string | null;
  catch_all_mailboxes?: string[] | null;
  catch_all_mailbox?: string | null;
}): string[] {
  const plural = value.catchAllMailboxes !== null && value.catchAllMailboxes !== undefined
    ? value.catchAllMailboxes
    : value.catch_all_mailboxes !== null && value.catch_all_mailboxes !== undefined
      ? value.catch_all_mailboxes
      : null;
  if (plural !== null) return uniqueMailboxIds(plural);
  return uniqueMailboxIds([value.catchAllMailbox, value.catch_all_mailbox]);
}
